import React, { useRef, useState } from 'react'
import FormTextField from '../FormTextField'
import { FormLabel, Typography, makeStyles, ClickAwayListener } from '@material-ui/core'
import styles from "./styles";
import { SketchPicker } from 'react-color';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const ColorFormTextField = (props) => {
  const {
    label,
    addAdditionalText,
    handleChange,
    value,
    colorFormTextField,
    id,
  } = props

  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const colorFieldRef = useRef(null);


  const [openColorPallete, setOpenColorPallete] = useState(false);

  const handleChangeColor = (e) => {
    setOpenColorPallete(true);
    handleChange(e?.hex)
  }

  const handleClickAway = () => {
    setOpenColorPallete(false);
  }

  const onClickInput = () => {
    setOpenColorPallete(value => !value)
  }

  const fieldContainer = clsx(classes.flex, classes.fieldContainer)

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className={fieldContainer} >
        <FormLabel className={classes.label}>{label}</FormLabel>
        <FormTextField
          {...props}
          label={label}
          onClickInput={colorFormTextField && onClickInput}
          addAdditionalText={addAdditionalText}
          prefixIcon={
            colorFormTextField && <div data-apim-test={`color-box-${id}`} id={`color-box-${id}`} onClick={onClickInput} className={classes.bgColorBox} style={{ backgroundColor: `${value || "white"}` }} />
          }
        />
        {addAdditionalText &&
          <Typography
            id={`additional-text-${id}`}
            data-apim-test={`additional-text-${id}`}
            className={classes.additionalText}
          >
            {addAdditionalText}
          </Typography>}
        {openColorPallete &&
          <div ref={colorFieldRef}>
            <SketchPicker className={classes.sketchPicker} onChange={handleChangeColor} color={value || "white"} />
          </div>
        }
      </div>
    </ClickAwayListener>
  )
}

ColorFormTextField.propTypes = {
  label: PropTypes.string,
  addAdditionalText: PropTypes.string,
  additionalTextId: PropTypes.string,
  handleChange: PropTypes.func,
  value: PropTypes.string,
  colorFormTextField: PropTypes.bool,
  id: PropTypes.string,
}

export default ColorFormTextField;
